// Breakpoints from https://primer.style/css/support/breakpoints
const sm = 544
const md = 768
const lg = 1012
const xl = 1280
const breakpoints = {sm, md, lg, xl}
type Breakpoints = keyof typeof breakpoints

export const isGtBreakpoint = (breakpoint: Breakpoints) => {
  switch (breakpoint) {
    case 'sm':
      return window.innerWidth >= sm
    case 'md':
      return window.innerWidth >= md
    case 'lg':
      return window.innerWidth >= lg
    case 'xl':
      return window.innerWidth >= xl
    default:
      return false
  }
}

export const isTouchEnabled = () => {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0
}

export const getCookie = (name: string) => {
  const matches = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}\\s*=\\s*([^;]+)`))
  return matches ? matches[1] : null
}

export const cookieExpiration = (days: number) => {
  const date = new Date()
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1e3)
  return date.toUTCString()
}

export const setCookie = (name: string, value: string, days: number) => {
  document.cookie = `${name}=${value}; path=/; expires=${cookieExpiration(days)}`
}
